<template>
    <div class="row">
        <div class="col-md-12" v-if="products.length">
            <div class="table_header">
                <div class="table_header_box for_desktop">Compare</div>
                <div class="table_header_box">Shape</div>
                <div class="table_header_box">Carat</div>
                <div class="table_header_box">Color</div>
                <div class="table_header_box">Clarity</div>
                <div class="table_header_box">Cut</div>
                <div class="table_header_box for_desktop">Report</div>
                <div class="table_header_box">Price</div>
            </div>
        </div>
        <div class="col-md-12" v-for="data in products" :key="data.id">
            <div class="diam_box skeleton_box border-0" v-if="data.key === 'empty_state'">
                <p class="placeholder-glow mb-0 mt-2">
                    <span class="placeholder col-12 p-4"></span>
                </p>
            </div>

            <div class="diamond_table" v-else>
                
                <div class="diamond_table_box_mod for_desktop_mod">
                    <div class="checkbox_custom tooltip_box ml-0" @click="addDiamondToCompare(data)">
                        <span :class="{ 'checked' : data.is_compared_count === 1,  'unchecked' : data.is_compared_count === 0 }"></span>
                        <label class="mb-0"></label>
                        <div class="tooltip_text" v-if="data.is_compared_count === 0">Add to Compare</div>
                        <div class="tooltip_text" v-if="data.is_compared_count === 1">Remove from Compare</div>
                    </div>
                </div>
                <div class="mobile-quick-view w-100">
                    <NuxtLink :to="localePath(detailPath(data.slug))" class="w-100">
                        <div class="diamond_table_flex">
                            <div class="diamond_table_box diamond_table_box_shape">
                                <div class="shape_mod">
                                    <SvgShapeSvg :type="data.shape_one" class="me-2 for_desktop" />
                                    <span>{{data.shape_one}}</span>
                                </div>
                            </div>
                            <div class="diamond_table_box">
                                <span>{{data.carat_one}} Ct</span>
                                <span>{{data.carat_two}} Ct</span>
                            </div>
                            <div class="diamond_table_box">
                                <span>{{data.color_one}}</span>
                                <span>{{data.color_two}}</span>
                            </div>
                            <div class="diamond_table_box">
                                <span>{{data.clarity_one}}</span>
                                <span>{{data.clarity_two}}</span>
                            </div>
                            <div class="diamond_table_box">
                                <span>{{data.cut_grade_one}}</span>
                                <span>{{data.cut_grade_two}}</span>
                            </div>
                            <div class="diamond_table_box for_desktop">
                                <span>{{data.report_one}}</span>
                                <span>{{data.report_two}}</span>
                            </div>
                            <div class="diamond_table_box">
                                <span>{{$formatPrice(data.price_one)}}</span>
                                <span>{{$formatPrice(data.price_two)}}</span>
                            </div>
                        </div>
                    </NuxtLink>
                    <div  @click.stop="handleQuickView(data)" class="for_mobile quick-view-toggle" ></div>
                </div>
            </div>
        </div>

        <CyoLooseQuickViewPairDiamondQuickView 
            class="for_mobile"  
            :data="quickViewProduct" 
            :openQuickDiamondView="openQuickDiamondView"
            @closeDiamondQuickView="closeDiamondQuickView"  
            @openDetailsPage="openDetailsPage"
        />
    </div>
</template>

<script setup>

    import {cyolistStore}  from '@/stores/cyolist/cyolist';
    import {compareStore}  from '@/stores/diamond_compare/diamond_compare';

    const quickViewProduct = ref(null)
    const openQuickDiamondView = ref(null)

    const router = useRouter()

    const localePath = useLocalePath()
    // Use Vuex store
    const store = cyolistStore()
    const storeCompare = compareStore()
    const { $toast, $formatPrice, $looseViewGtag } = useNuxtApp()
    const route = useRoute()
    
    const moduleSubType = route.meta.moduleSubType

    // Computed properties
    const products = computed(() => store.getSettingListingResult())
    const showSkeleton = computed(() => store.getSettingShowSkeleton())

    function triggerGtag(data){
        if(moduleSubType === 'loose'){
            $looseViewGtag(data)
        }
    }

    const detailPath = (slug) => {
        triggerGtag()
        if (['ring', 'earring', 'pendant'].includes(moduleSubType)) {
            return { name: 'cyo-diamond-detail-' + moduleSubType, params: { slug } }
        }
        return { name: 'loose-detail', params: { slug:slug } }
    }

    const addDiamondToCompare = (diamond) => {
        storeCompare.addToCompare( { moduleSubType: moduleSubType, diamond:diamond })
            .then((res) => {

                if( res?.status && res?.status == 'error' ){

                    $toast('alert', res.status, res.msg);
                }
                // store.dispatch('toast', { type: 'success', title: res.status, text: res.msg })
            })
    }

    const openDiamondQuickView = (data)=>{
        document.body.classList.add('filter_open');
        quickViewProduct.value = data
        
        nextTick(()=>{
            openQuickDiamondView.value = true
        })
    }

    const closeDiamondQuickView = ()=>{
        document.body.classList.remove('filter_open');
        openQuickDiamondView.value = false
        // setTimeout(()=>{
        //     quickViewProduct.value = null
        // },500)
    }

    const openDetailsPage = (slug)=>{
        closeDiamondQuickView()
        router.push(localePath(detailPath(slug)))   
    }
    const handleQuickView = (data)=>{
        triggerGtag(data)
        openDiamondQuickView(data)
    }

      
           
</script>

<style scoped>

.shape_mod {
    display: flex;
    align-items: center;
    justify-content: flex-start;
}
.diamond_table_box span {
    display: block;
    padding: 3px 0;
}
.table_header {
    display: flex;
    align-items: center;
    background: #e2e2e2;
}
/* .table_header_box:first-child, .table_header_box:last-child {
    width: 8%;
} */
.table_header_box {
    font-size: 14px;
    color: #111827;
    font-weight: 600;
    width: 12.8%;
    border-right: 3px solid #FFF;
    padding: 5px 15px;
    text-align: center;
}
.table_header_box_mod {
    font-size: 14px;
    color: #111827;
    font-weight: 600;
    width: 8%;
    border-right: 3px solid #FFF;
    padding: 5px 15px;
}
.table_header_box:last-child {
    border: 0;
}

/* --------------- */

.diamond_table {
    display: flex;
    align-items: center;
    height: auto;
    border-bottom: 1px solid #e7eaee;
}
.diamond_table_box {
    font-size: 14px;
    color: #212529;
    font-weight: 400;
    width: 14.28%;
    padding: 5px 18px;
    text-transform: capitalize;
    text-align: center;
}

.diamond_table:nth-child(odd) {
  background: #f9f9f9;
}
.diamond_table:nth-child(even) {
  background: #fff;
}
.diamond_table_box_mod {
    font-size: 14px;
    color: #111827;
    font-weight: 600;
    width: 12.8%;
    padding: 5px 15px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.diamond_table a {
    /* width: 87.2%; */
    display: inline-block;
}
.diamond_table_flex {
    width: 100%;
    display: flex;
    align-items: center;
}

@media(max-width: 1024px){
    .for_desktop_mod{
        display: none;
    }
    .table_header_box, .diamond_table_box{
        width: 16.66%;
        padding: 5px 6px;
    }
    .diamond_table a{
        width: 100%;
    }
}
@media(max-width: 767px){
    .col-md-12 {
        padding: 0;
    }


    .mobile-quick-view{
        position: relative;
        pointer-events: none;
        
    }

    .quick-view-toggle{
        width: 100%;
        position: absolute;
        top: 0px;
        left: 0px;
        height: 100%;
        pointer-events: auto;
    }
}
</style>
